import Chat from '../Chat';
import GradientIcon from '../GradientIcon';
import Icon from '../Icon';
import Select from '../Select';
import Box from '../UI/Box';
import ButtonBase from '../UI/ButtonBase';
import Text from '../UI/Text';
import useChatFloating from './hooks/useChatFloantig';
import * as SC from './styles';

const ChatFloantig = () => {
  const {
    isOpenBox,
    options,
    promptParam,
    dataParam,
    distance,
    handleChangeBox,
    handleOnChange,
  } = useChatFloating();
  const renderButtonOrBoxChat = () => {
    if (isOpenBox) {
      return (
        <Box
          flexDirection="column"
          width={450}
          borderRadius={100}
          height={570}
          boxShadow={'0 -10px 50px #0d86ff3b , 0 10px 50px #44d78961 '}
        >
          <SC.Header>
            <Box alignItems="center" justifyContent="center" gap={5}>
              <Icon iconName="AutoAwesomeOutlined" size={24} htmlColor="#fff" />
              <Text color="#fff" fontSize={18} fontWeight={700}>
                Greenfy I.A
              </Text>
            </Box>

            <Box gap={5}>
              <Select
                options={options}
                value={'default'}
                onChange={handleOnChange}
                width={130}
                labelId="sugestoes-label"
                selectId="sugestoes"
              />
              <ButtonBase
                onClick={handleChangeBox}
                alignItems="center"
                justifyContent="center"
              >
                <Icon iconName="RemoveOutlined" size={24} htmlColor="#fff" />
              </ButtonBase>
            </Box>
          </SC.Header>

          <Box
            background={'#fff'}
            height={'100%'}
            padding={10}
            borderRadius={'0 0 32px 32px'}
            flexDirection="column"
            overflowY="auto"
          >
            <Chat floating promptParam={promptParam} data={dataParam} />
          </Box>
        </Box>
      );
    }

    return (
      <SC.Button onClick={handleChangeBox}>
        <GradientIcon
          iconName="AutoAwesomeOutlined"
          colors={['#fff', '#fff', '#5ed897', '#a7ffd0']}
          size={50}
        />
      </SC.Button>
    );
  };
  return (
    <Box position="fixed" right={distance} bottom={distance} zIndex={3}>
      {renderButtonOrBoxChat()}
    </Box>
  );
};

export default ChatFloantig;
